export default __webpack_public_path__ + "static/hero-l5-bg-course3-80e4bfb62a031da1805cc011ebccf598.png";